import { useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import CategoriesFilterSelect from '@features/categories/components/CategoriesFilterSelect/CategoriesFilterSelect';
import CategoriesFilterMultiselect from '@features/categories/components/CategoriesFilterMultiselect/CategoriesFilterMultiselect';
import CategoriesFilterBoolean from '@features/categories/components/CategoriesFilterBoolean/CategoriesFilterBoolean';
import FilterSelectState from '@features/categories/mobx/state/FilterSelectState';
import FilterMultiselectState from '@features/categories/mobx/state/FilterMultiselectState';
import FilterRangeState from '@features/categories/mobx/state/FilterRangeState';
import CategoriesFilterRange from '@features/categories/components/CategoriesFilterRange/CategoriesFilterRange';
import FilterSortState from '@features/categories/mobx/state/FilterSortState';
import styles from '@features/categories/components/CategoriesFilterDropdown/CategoriesFilterDropdown.styles';
import FilterState from '@features/categories/mobx/state/FilterState';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import ChevronRight from '@components/icons/components/ChevronRight';
import FilterBooleanState from '@features/categories/mobx/state/FilterBooleanState';
type PropsType = {
  filter: FilterState;
  withAppTranslation?: boolean;
};
const CategoriesFilterDropdown = ({
  filter,
  withAppTranslation = false
}: PropsType) => {
  const [active, setActive] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const {
    t
  } = useTranslation('filters');
  useEffect(() => {
    const onOutsideClick = (event: MouseEvent) => {
      let targetElement = event.target as HTMLElement;
      do {
        if (!dropdownRef.current) return;
        const {
          children
        } = dropdownRef.current;
        if (Array.from(children).some(child => targetElement === child)) return;
        targetElement = targetElement.parentElement as HTMLElement;
      } while (targetElement);
      setActive(false);
    };
    window.addEventListener('click', onOutsideClick);
    return () => window.removeEventListener('click', onOutsideClick);
  }, []);
  const onClick = () => {
    setActive(state => !state);
  };
  const renderDropdownFilter = () => <div key={filter.key}>
      {filter instanceof FilterSelectState && <CategoriesFilterSelect key={filter.key} filter={filter} dropdown />}
      {filter instanceof FilterSortState && <CategoriesFilterSelect key={filter.key} filter={filter} dropdown sort />}
      {filter instanceof FilterMultiselectState && <CategoriesFilterMultiselect key={filter.key} filter={filter} dropdown />}
      {filter instanceof FilterRangeState && <CategoriesFilterRange key={filter.key} filter={filter} dropdown />}
      {filter instanceof FilterBooleanState && <CategoriesFilterBoolean key={filter.key} filter={filter} dropdown />}
    </div>;
  return <div data-cy="CategoriesFilterDropdown" ref={dropdownRef} sx={styles.dropdownContainer}>
      <Button variant="link" onClick={onClick} variantColor="dark" size="small" addSx={styles.button}>
        <span sx={styles.buttonText}>{withAppTranslation ? t(filter.name.toLowerCase()) : filter.name}</span>
        <div sx={styles.dropdownIcon(active)}>
          <Icon size="24px">
            <ChevronRight />
          </Icon>
        </div>
      </Button>
      {active && <div sx={styles.dropdown(active)}>{renderDropdownFilter()}</div>}
    </div>;
};
export default observer(CategoriesFilterDropdown);